<template>
  <div class="tabela-empresas">
    <Paginacao scrollDown produtos :conteudo="conteudo" @pagina="p => (empresasPaginadas = p)">
      <TabelaPadrao
        templateColumns="160px 80px 1fr"
        acao="190px"
        :conteudoPaginado="empresasPaginadas"
        :conteudoTotal="conteudo"
        :estruturaTabela="estruturaTabela"
        :deleteTabela="deleteTabela"
        :editTabela="editTabela"
        :syncTabela="syncTabela"
        :cnaeTabela="cnaeTabela"
      />
    </Paginacao>
  </div>
</template>

<script>
import TabelaPadrao from "@/components/TabelaPadrao/TabelaPadrao.vue";
import Paginacao from "@/components/Paginacao/Paginacao.vue";
import filtros from "@/store/modules/cenarioFiltros.js";

export default {
  name: "TabelaEmpresas",
  components: {
    TabelaPadrao,
    Paginacao
  },
  props: {
    conteudo: Array,
    deleteTabela: Function,
    editTabela: Function,
    syncTabela: Function,
    cnaeTabela: Function
  },
  data() {
    return {
      filtros,
      empresasPaginadas: [],
      estruturaTabela: [
        { nome: "CNPJ", valor: "cnpj", alinhamento: "centro" },
        {
          nome: "UF",
          valor: "uf",
          alinhamento: "centro",
          alerta: "Atualize o cadastro da empresa"
        },
        { nome: "NOME", valor: "nome" }
      ]
    };
  }
  // created() {
  // if (this.conteudo) {
  //   this.conteudo.forEach(e => {
  //     let sigla = this.filtros.estado_origem.valores.find(f => f.value == e.id_uf);
  //     e.uf = sigla ? sigla.sigla : "";
  //   });
  // }
  // }
};
</script>

<style lang="scss" scoped>
.tabela-empresas {
  width: 100%;
}
</style>
